import { AfterViewInit, Component, Input, ViewEncapsulation } from '@angular/core';
import { OrderStatus } from '../../../smoothr-web-app-core/enums/OrderStatus';
import { numberToCurrency, sleep } from '../../../smoothr-web-app-core/utils/utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { NavigationService } from 'src/app/services/navigation.service';
import { ValidationUtils } from 'src/smoothr-web-app-core/utils/validation-utils';
import { ModalController } from '@ionic/angular';
import dayjs, { isDayjs, Dayjs } from 'dayjs';

@Component({
	selector: 'app-my-order',
	templateUrl: './my-order.component.html',
	styleUrls: ['my-order.component.scss'],
	encapsulation: ViewEncapsulation.Emulated,
	standalone: false,
})
export class MyOrderComponent implements AfterViewInit {
	@Input() order: Order;

	showQr = false;
	os = OrderStatus;
	pt = PreorderType;
	numberToCurrency = numberToCurrency;
	OrderUtils = OrderUtils;
	@Input() showMinInfo = false;
	loading = false;

	constructor(
		private repository: RepositoryService,
		private router: Router,
		private snackbarCtrl: MatSnackBar,
		private translate: TranslateService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController
	) {}

	ngAfterViewInit(): void {}

	formatTime(dateTime: Dayjs): string {
		if (!isDayjs(dateTime)) return dayjs(dateTime).format('HH:mm / DD.MM.yyyy');
		return dateTime.format('HH:mm / DD.MM.yyyy');
	}

	async reorder() {
		console.log('THIS reorder', this.order);
		if (this.loading) {
			return;
		}
		this.loading = true;
		try {
			await this.repository.reorder(this.translate, this.order);
			try {
				await this.modalCtrl.dismiss();
			} catch (e) {}
			await this.navigationService.order(true);

			this.loading = false;
		} catch (e) {
			console.error(e);
			this.snackbarCtrl.open(e.message ? e.message : this.translate.instant('my_order.reorder_error'), null, {
				duration: 2000,
			});
		}
		this.loading = false;
	}
}
